import Pubnub from 'pubnub';
import { createAsyncThunk } from '@reduxjs/toolkit';

import { RootState } from '../../..';
import { getErrorText } from '../helpers';

export const getBlockedUsersCount = createAsyncThunk<
  Pubnub.MessageCountsResponse['channels'],
  { roomId: string },
  { rejectValue: string }
>('pubnub/getBlockedUsersCount', async (data, { rejectWithValue, getState }) => {
  try {
    const pubnubReducer = (getState() as RootState).pubnub;
    const { roomId } = data;
    const timeToken = `${946677600000 * 10000}`; // new Date('01.01.2000') - 946677600000

    if (pubnubReducer.pubnub) {
      const result = await pubnubReducer.pubnub.messageCounts({
        channels: [roomId],
        channelTimetokens: [timeToken],
      });

      return result.channels;
    } else {
      throw new Error('PubnubInstanceIsNull');
    }
  } catch (e) {
    return rejectWithValue(getErrorText(e as Error));
  }
});
